"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.UserInfo = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Icon = require("../../../UIElements/Icons/PetSure/Icon");
var _pageStatePropTypes = require("../../../../propTypes/pageStatePropTypes");
require("./userInfo.scss");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const UserInfo = _ref => {
  let {
    user,
    showPhotoLogo = false,
    condensed = false
  } = _ref;
  const {
    photo,
    name
  } = user;
  const initials = name.split(' ').map(namePiece => namePiece.substring(0, 1)).join('').toUpperCase();
  const hoverTitle = "Logged in as ".concat(name);
  return /*#__PURE__*/_react.default.createElement("span", {
    className: "userInfo ".concat(condensed ? 'condensed' : ''),
    title: hoverTitle
  }, showPhotoLogo ? /*#__PURE__*/_react.default.createElement("span", {
    className: "photo"
  }, /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    icon: "logo_icon_square_40"
  }), /*#__PURE__*/_react.default.createElement("img", {
    src: photo,
    alt: "Gravatar of ".concat(name)
  })) : /*#__PURE__*/_react.default.createElement("span", {
    role: "presentation",
    "aria-hidden": "true",
    className: "initials"
  }, initials), /*#__PURE__*/_react.default.createElement("span", {
    className: "info"
  }, name));
};
exports.UserInfo = UserInfo;
UserInfo.propTypes = {
  user: _pageStatePropTypes.UserPropTypes,
  showPhotoLogo: _propTypes.default.bool,
  condensed: _propTypes.default.bool
};
UserInfo.defaultProps = {
  condensed: false,
  showPhotoLogo: false
};
var _default = exports.default = UserInfo;